
<div class="mb-2">
    <a class="btn btn-secondary" [routerLink]="['/employees']">&lt; Employees</a>
</div>

<div *ngIf="Employee != null; else Loading" class="card">
    <div class="card-header mfp-header">
        <div class="d-flex justify-content-between">
            <h4 class="d-inline-block align-self-center mb-0">
                {{ Employee.FirstName + ' ' + Employee.LastName }}
                <ng-container *ngIf="Employee.PaycorID">
                    (ID: {{Employee.PaycorID}})
                </ng-container>
            </h4>
            <div class="d-inline-block">
                <button class="btn btn-secondary" (click)="EditEmployee()">Edit</button>
            </div>
        </div>
    </div>
    <div class="card-body">
        <div class="container-fluid">
            <div class="row">
                <div class="col-12 col-md-8 offset-md-2 col-lg-4 offset-lg-1">
                    <div class="row my-2">
                        <div class="col-12 col-md-6 fw-bold">
                            Phone Number:
                        </div>
                        <div class="col-12 col-md-6 text-end">
                            {{ Employee.PhoneNumber }}
                        </div>
                    </div>
                    <div class="row my-2" *ngFor="let department of Employee.Departments; index as i; first as isFirst">
                        <div class="col-12 col-md-6 fw-bold"><span *ngIf="isFirst">Departments:</span></div>
                        <div class="col-12 col-md-6 text-end">
                            <span [innerText]="department.Name"></span>
                        </div>
                    </div>
                    <div class="row my-2" *ngIf="!Employee.Departments.length">
                        <div class="col-12 col-md-6 fw-bold">Departments:</div>
                        <div class="col-12 col-md-6 text-end">
                            <span class="fst-italic text-muted">None</span>
                        </div>
                    </div>
                    <div class="row my-2">
                        <div class="col-12 col-md-6 fw-bold">
                            Active:
                        </div>
                        <div class="col-12 col-md-6 text-end">
                            {{ Employee.IsActive ? 'Yes' : 'No' }}
                        </div>
                    </div>
                </div>
                <div class="col-12 col-md-8 offset-md-2 col-lg-4 offset-lg-2">
                    <div class="row my-2">
                        <div class="col-12 col-md-8 fw-bold">
                            Start Date:
                        </div>
                        <div class="col-12 col-md-4 text-end">
                            {{ Employee.StartDate | date:'shortDate' }}
                        </div>
                    </div>
                    <div class="row my-2">
                        <div class="col-12 col-md-8 fw-bold">
                            Birthday:
                        </div>
                        <div class="col-12 col-md-4 text-end">
                            {{ Employee.BirthDate | date:'shortDate' }}
                        </div>
                    </div>
                    <div class="row my-2">
                        <div class="col-12 col-md-8 fw-bold">
                            Last Day:
                        </div>
                        <div class="col-12 col-md-4 text-end">
                            {{ Employee.EndDate | date:'shortDate' }}
                        </div>
                    </div>
                </div>
                <div class="col-12 mt-3">
                    <div class="row">
<!--                        <div class="col-12 col-md-8 offset-md-2 col-lg-4 offset-lg-1">-->
<!--                            <div class="row align-items-center">-->
<!--                                <div class="col-12 my-2 fw-bold">-->
<!--                                    Insurance Card:-->
<!--                                </div>-->
<!--                                <file-attachment-->
<!--                                    [(FileAttachment)]="Employee.InsuranceCard"-->
<!--                                    [EditMode]="EditMode"-->
<!--                                    [UploadHandler]="InsuranceCardUploader()"-->
<!--                                    [DeleteHandler]="InsuranceCardDeleter()">-->
<!--                                </file-attachment>-->
<!--                            </div>-->
<!--                        </div>-->
                        <div class="col-12 col-md-8 offset-md-2 col-lg-4 offset-lg-2">
                            <div class="row align-items-center">
                                <div class="col-12 my-2 fw-bold">
                                    File Attachments:
                                </div>
                                <file-attachment-list
                                    [FileList]="Employee.FileAttachments"
                                    [EditMode]="EditMode"
                                    [UploadHandler]="FileUploader()"
                                    [DeleteHandler]="FileDeleter()">
                                </file-attachment-list>
                            </div>
                        </div>
                    </div>
                    <div class="row mt-4">
                        <div class="col-12 text-center">
                            <button type="button"
                                    class="btn btn-secondary"
                                    (click)="EditMode = !EditMode">
                                {{EditMode ? 'Done Editing' : 'Edit Documents'}}
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<ng-template #Loading>
    
</ng-template>